export default __webpack_public_path__ + "static/golden-russet-black-c8ff62e11875b024c13e9c93d040cd1c.svg";